"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Buttons_1 = require("../../Buttons");
var Thumbnails_1 = require("../../Thumbnails");
var TileButton_1 = require("../TileButton");
var TileArticleList_styles_1 = require("./TileArticleList.styles");
var buildFieldItemContent = function (item) {
    return (React.createElement(React.Fragment, null,
        React.createElement(TileArticleList_styles_1.LabelText, null, item.Label),
        typeof item.Value === "string" ?
            React.createElement(TileArticleList_styles_1.ValueText, null, item.Value)
            :
                item.Value()));
};
exports.default = (function (_a) {
    var Items = _a.Items, FieldColumnNumber = _a.FieldColumnNumber;
    return (React.createElement(TileArticleList_styles_1.Ul, null, Items.map(function (item, index) {
        return (React.createElement(React.Fragment, { key: item.Key ? item.Key : item.Header },
            React.createElement(TileArticleList_styles_1.ListItem, { ShowPhoto: item.AvatarThumbnail !== undefined },
                item.AvatarThumbnail &&
                    React.createElement(Thumbnails_1.AvatarThumbnail, __assign({}, item.AvatarThumbnail, { Size: "Large" })),
                React.createElement(TileArticleList_styles_1.Container, null,
                    React.createElement(TileArticleList_styles_1.HeaderContainer, null,
                        React.createElement(TileArticleList_styles_1.HeaderAndStatusContainer, null,
                            React.createElement(TileArticleList_styles_1.H2, null, item.Header),
                            item.StatusMarker &&
                                item.StatusMarker()),
                        React.createElement(TileArticleList_styles_1.ActionsContainer, null,
                            item.AdditionalLabel &&
                                item.AdditionalLabel(),
                            item.TileButton &&
                                React.createElement(TileButton_1.default, __assign({}, item.TileButton)),
                            item.OptionsButton &&
                                React.createElement(TileArticleList_styles_1.OptionsButtonContainer, null,
                                    React.createElement(Buttons_1.OptionsButton, __assign({}, item.OptionsButton))))),
                    React.createElement(TileArticleList_styles_1.FieldsUl, { Columns: FieldColumnNumber }, item.Fields.map(function (field) {
                        return (React.createElement(TileArticleList_styles_1.FieldListItem, { key: field.Label }, buildFieldItemContent(field)));
                    })))),
            index !== Items.length - 1 &&
                React.createElement("li", { key: index, role: "presentation", "aria-hidden": true },
                    React.createElement(TileArticleList_styles_1.Line, null))));
    })));
});
